/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ApplicationType = "MAIN_APP" | "OPERATOR_PORTAL";
export type FormFieldType = "CHECKBOX" | "DATE" | "MULTILINE_TEXT" | "MULTISELECT" | "NUMBER" | "SELECT" | "SELECT_CUSTOMER" | "SELECT_MACHINE" | "SELECT_ORDER" | "SELECT_USER" | "TEXT";
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormBuilder_formField$ref: FragmentReference;
declare export opaque type FormBuilder_formField$fragmentType: FormBuilder_formField$ref;
export type FormBuilder_formField = {|
  +id: string,
  +systemKey: ?string,
  +type: FormFieldType,
  +name: string,
  +description: ?string,
  +placeholder: ?string,
  +isRequired: boolean,
  +isCreatable: boolean,
  +applicationType: ApplicationType,
  +displayOrder: number,
  +properties: ?any,
  +options: $ReadOnlyArray<{|
    +name: string,
    +value: string,
  |}>,
  +$refType: FormBuilder_formField$ref,
|};
export type FormBuilder_formField$data = FormBuilder_formField;
export type FormBuilder_formField$key = {
  +$data?: FormBuilder_formField$data,
  +$fragmentRefs: FormBuilder_formField$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "FormBuilder_formField",
  "type": "FormField",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "systemKey",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isRequired",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCreatable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "applicationType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "properties",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "options",
      "storageKey": null,
      "args": null,
      "concreteType": "FormFieldOption",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '00308040684462d7033514bb566184bc';
module.exports = node;
